import React, { useEffect } from "react";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import styled from "styled-components";
import "../../styles/CustomModal.css";
import { ExceedType } from "../../recoil/exceed";
import moment from "moment";
import { getRecoil } from "recoil-nexus";
import { chatState } from "../../recoil/chat";

const ChatAlertModal = (oProps: {
  isVisible: boolean;
  setVisible: (isVisible: boolean) => void;
  onConfirm: any;
}) => {
  const onCloseModal = () => {
    oProps.setVisible(false);
  };

  return (
    <Modal
      open={oProps.isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "optionCustomOverlay",
        modal: "chatAlertModal",
      }}
      closeOnOverlayClick={false}
      showCloseIcon={false}
      animationDuration={150}
    >
      <Style>
        <div className="modal">
          <img
            className="closeIcon"
            onClick={onCloseModal}
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
            alt="ic"
          />
          <img
            className="message"
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_message.svg`}
            alt="message"
          />
          <h3>
            {getRecoil(chatState).area_name.length > 0
              ? `${getRecoil(chatState).area_name} 주문고객의\n`
              : "" + "새로운 메시지가 도착했어요"}
          </h3>
          <div className="bottomButtonWrap">
            <div className="confirmButton" onClick={oProps.onConfirm}>
              메시지 보기
            </div>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default ChatAlertModal;

const Style = styled.div`
  .modal {
    width: 100%;
    text-align: center;
    padding: 20px 20px 0 20px;
  }

  .closeIcon {
    position: absolute;
    top: 5%;
    right: 4%;
    cursor: pointer;
  }

  img.message {
    height: 60px;
  }

  .row {
    padding-left: 18%;
    display: flex;
    align-items: center;
  }

  h3 {
    padding-top: 16px;
    padding-bottom: 24px;
    font-size: 18px;
    line-height: 30px;
    font-weight: 500;
    color: #555555;
  }

  h4 {
    font-size: 18px;
    line-height: 32px;
    font-weight: 400;
    color: #555555;
    text-align: center;
    width: 120px;
  }

  span {
    font-size: 20px;
    font-weight: 600;
    color: #555555;
  }

  .bottomButtonWrap {
    width: 100%;
    display: flex;

    .confirmButton {
      width: 100%;
      padding: 14px;
      font-size: 24px;
      line-height: 28px;
      border-radius: 10px;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
      color: #ffffff;
      background: #4dd2ae;
      border: 1px solid #4dd2ae;
    }
  }
`;
